import * as Factory from 'factory.ts'
import faker from 'faker'

import { type UserApprovalDelegateeApiModel } from '../UserApprovalDelegateeApiModel'

export const UserApprovalDelegateeApiModelStub =
  Factory.Sync.makeFactory<UserApprovalDelegateeApiModel>({
    id: Factory.each(() => faker.random.number()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    email: Factory.each(() => faker.internet.email()),
    expected_return_date: faker.date.past(10).toISOString(),
  })
